export default __webpack_public_path__ + "static/media/Milena Barros_.5ae62aec.png";